import { WechatAuthState } from '@interfaces/auth'
import { isWeChat } from '@utils'
import { getWechatOAuthUrl } from '@utils/wechat'
import React, { FC, useState } from 'react'
import QRCodeModal from './QRCodeModal'
import './styles.css'

interface WeChatAuthProps {
  state: WechatAuthState
  children?: React.ReactNode
}

// Two way to ask the code from wechat
// 1. Redirect to wechat site when it's in the wechat browser (public account)
// 2. Display QR code to allow user to scan (open platform)
const WeChatAuth: FC<WeChatAuthProps> = ({ state, children, bind }) => {
  const [open, setOpen] = useState<boolean>(false)

  const handleClick = (e: React.MouseEvent<HTMLElement>) => {
    // Ignore the default behaviour of the anchor and open the modal instead
    if (!isWeChat()) {
      e.preventDefault()
      setOpen(true)
    }
  }

  //     const pathname = (() => {
  //       if (this.props.state?.from?.pathname) {
  //         return this.props.state.from.pathname
  //       }
  //       return location.pathname
  //     })()
  //
  //     const redirectUrl = `${location.origin}${pathname}?${encodeURIComponent(location.search)}&public=0`
  const url = getWechatOAuthUrl(state)

  return (
    <>
      <a href={url} onClick={handleClick}>
        {children || (
          <div styleName="wechatIcon">
            <i className="icon-wechat fa-2x" />
          </div>
        )}
      </a>

      <QRCodeModal bind={bind} open={open} onClose={() => setOpen(false)} />
    </>
  )
}

export default WeChatAuth
